module.exports = __webpack_public_path__ + "media/seher_1.1e.c8c1032c.mp3";